import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tnimm2-page',
  templateUrl: './tnimm2-page.component.html',
  styleUrls: ['./tnimm2-page.component.css']
})
export class Tnimm2PageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
